import React, { ComponentProps } from 'react';

import { twMerge } from 'tailwind-merge';

import { BaseButton } from './BaseButton';

interface ButtonGroupProps {
  readonly orientation?: 'horizontal' | 'vertical';
  readonly children: React.ReactElement<ComponentProps<typeof BaseButton>> | React.ReactElement<ComponentProps<typeof BaseButton>>[];
  readonly className?: string;
}

function ButtonGroup({ children, orientation = 'horizontal', className }: ButtonGroupProps) {
  const classes = twMerge('flex', orientation === 'horizontal' ? 'flex-row' : 'flex-col', className);
  const total = React.Children.count(children);

  return (
    <div className={classes}>
      {total > 1
        ? React.Children.map(children, (child, index) => {
            let rounding: (typeof child)['props']['rounding'] = 'default';
            let border = '';

            if (orientation === 'horizontal') {
              switch (index) {
                case 0:
                  rounding = 'left';
                  border = 'border-r-0';
                  break;
                case total - 1:
                  rounding = 'right';
                  break;
                default:
                  rounding = 'none';
                  border = 'border-r-0';
              }
            } else {
              switch (index) {
                case 0:
                  rounding = 'top';
                  border = 'border-b-0';
                  break;
                case total - 1:
                  rounding = 'bottom';
                  border = 'default';
                  break;
                default:
                  rounding = 'none';
                  border = 'border-b-0';
              }
            }

            return React.cloneElement(child, {
              rounding,
              className: twMerge(child.props.className, border, 'focus:ring-inset focus:ring-neutral-300/50'),
            });
          })
        : children}
    </div>
  );
}

export { ButtonGroup };
